import { Component, forwardRef } from "@angular/core";
import { UserActionBaseComponent } from "../userAction-base.component";
import { LoginService } from "app/Services/login.service";
import { MacroService } from "app/Services/CatalogManagement/macro.service";
import { Macro } from "app/Model/ui/Macro";

@Component({
    selector: 'userAction-setWawiLines',
    templateUrl: './userAction-setWawiLines.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionSetWawiLinesComponent) }
    ],
    standalone: false
})
export class UserActionSetWawiLinesComponent extends UserActionBaseComponent {
  fillWawi: boolean = true;
  fillDpb: boolean = false;
  createMatchcode: boolean = false;

  constructor(public loginService: LoginService, public macroService: MacroService) {
    super(loginService, macroService);
  }

  get hasDpbAddon(): boolean {
    return this.loginService.hasAddonDpbImport || this.loginService.hasAddonDpbExport;
  }

  onFillDpbChanged() {
    if (!this.fillDpb)
      this.createMatchcode = false;
  }

  public override getActionId(macro: Macro): string {
    return `SetWawiLines(${this.fillWawi}:${this.fillDpb}:${this.fillDpb && this.createMatchcode})`;
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({
      fillWawi: this.fillWawi,
      fillDpb: this.fillDpb,
      createMatchcode: this.createMatchcode
    });
  }

  public parseParameter(parameter: string) {
    if (!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.fillWawi = parsed.fillWawi;
      this.fillDpb = parsed.fillDpb;
      this.createMatchcode = parsed.createMatchcode ?? false;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
